import type { IPaginatedCommentsData } from './types';
import type { InfiniteData } from '@tanstack/react-query';
import type { IUseCommentMeta } from 'infrastructure/interfaces';
import type { ISocketInteractiveTimeData } from 'infrastructure/interfaces/i-rpm-patient-activity';

export const generalCommentsApi = (patientGuid: string) =>
  `core/patients/${patientGuid}/comments`;

export const generateCommentsQueryKey = (
  filters: IUseCommentMeta & { patientGuid: string },
) =>
  [
    generalCommentsApi(filters.patientGuid),
    filters.commentType,
    filters.startTime,
    filters.endTime,
  ].filter((val) => val);

export const addDocumentationTime = (
  oldData: InfiniteData<IPaginatedCommentsData> | undefined,
  socketData: ISocketInteractiveTimeData,
) => {
  if (!oldData) return oldData;

  const dataCache = structuredClone(oldData);
  const newPages = dataCache?.pages?.map((page) => {
    const comments = page.data.map((comment) => {
      if (comment.guid === socketData.actionGuid) {
        comment.documentationTime = socketData.time;
        return comment;
      }
      return comment;
    });
    return {
      ...page,
      data: comments,
    };
  });

  return {
    ...dataCache,
    pages: newPages,
  };
};
